import { AUTH_USER_TOKEN_KEY } from '../../constants';
import useInterval from '@hooks/useInterval';
import React, { useEffect } from 'react';
import getUserSession from '@utils/getSession';

const REFRESH_INTERVAL = 1000 * 60;

export default function AppSessionRefresh() {
  const [currentToken, setCurrentToken] = React.useState<string | null>(null);

  const fetchSession = async () => {
    const session = await getUserSession();

    if (session.token !== currentToken) {
      localStorage.setItem(AUTH_USER_TOKEN_KEY, session.token);
      setCurrentToken(session.token);
    }
  };

  useInterval(() => {
    fetchSession();
  }, REFRESH_INTERVAL);

  useEffect(() => {
    fetchSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
